// The asset-caching service worker has been removed. It only provided request
// timeouts (now handled directly in the asset loaders) and no caching, while
// being a source of intermittent, misleading CORS errors on asset loads.
//
// Existing sessions may still have it installed, so unregister our previously
// registered service worker to stop it intercepting requests. It was served from
// `/service-worker.js`, so we only unregister registrations whose worker script
// matches that, leaving any other (current or future) service worker untouched.
const OWN_SERVICE_WORKER_PATH = '/service-worker.js';

function isOwnServiceWorker(registration: ServiceWorkerRegistration): boolean {
    const worker = registration.active ?? registration.waiting ?? registration.installing;

    if (!worker) {
        return false;
    }

    return new URL(worker.scriptURL).pathname === OWN_SERVICE_WORKER_PATH;
}

if ('serviceWorker' in navigator) {
    navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => {
            registrations.filter(isOwnServiceWorker).forEach((registration) => {
                registration.unregister();
            });
        })
        .catch(() => {
            // Nothing actionable if unregistration fails.
        });
}
